<template>
  <template-info :bgImg="bgImg" title="แบบฟอร์มแต่ละแบบคืออะไร">
    <div>
      <span class="bold">แบบแจ้งรายได้พนักงานรอบรายปี ภ.ง.ด. 1ก</span>
      <div>
        ใบสรุปการจ่ายเงินเดือน ค่าจ้าง เบี้ยเลี้ยง โบนัส
        สวัสดิการอื่นที่จ่ายให้กับพนักงาน (เช่น ค่าเช่า) ภาษีที่นายจ้างออกแทนให้
        และภาษีของพนักงานรอบรายปี
        ซึ่งเจ้าของธุรกิจจะต้องทำส่งเพื่อแจ้งให้กรมสรรพากร
      </div>
      <br />
      <span class="bold">แบบแจ้งรายได้พนักงาน ภ.ง.ด. 1</span>
      <div>
        ใช้สำหรับแจ้งพนักงานที่มีรายได้ถึงฐานที่ต้องเสียภาษีแล้วเท่านั้น
        และต้องทำส่งกรมสรรพากรทุกเดือน ภายในวันที่ 7 ของเดือนถัดไปทุกเดือน
      </div>
      <br />
      <span class="bold">แบบแจ้งภาษีหัก ณ ที่จ่าย ภ.ง.ด. 3</span>
      <div>
        แบบยื่นเพื่อแจ้งการหักภาษี ณ ที่จ่าย
        ของนิติบุคคลที่ทำธุรกรรมกับบุคคลธรรมดาที่เจ้าของธุรกิจ (นิติบุคคล)
        จะต้องหักออกจากค่าจ้างที่จ้างบุคคลภายนอกให้มาทำงานให้บริษัท
      </div>
      <br />

      <span class="bold">แบบภาษีเงินได้นิติบุคคล ภ.ง.ด. 50 </span>
      <div>
        แบบแสดงรายการภาษีเงินได้นิติบุคคล โดยการยื่น ภ.ง.ด. 50 จำต้องยื่นภายใน
        150 วันนับตั้งแต่วัน สุดท้ายของรอบระยะเวลาบัญชี โดยจะต้องยื่นทุกปี
        ไม่ว่าจะมีรายได้หรือไม่มีรายได้
      </div>
      <br />

      <span class="bold">แบบภาษีเงินได้นิติบุคคลครึ่งปี ภ.ง.ด. 51 </span>
      <div>
        แบบแสดงรายการภาษีเงินได้นิติบุคคลสำหรับครึ่งรอบระยะเวลาบัญชี (6 เดือน)
        หรืออธิบายง่ายๆว่าเป็นการ
        จ่ายภาษีนิติบุคคลให้กรมสรรพากรก่อนสำหรับกำไรในรอบ 6
        เดือนแรกหลังจากนั้นจึงคำนวณค่าภาษีอีกครั้ง ตอนสิ้นปี (ภ.ง.ด. 50)
      </div>
      <br />

      <span class="bold">แบบแจ้งภาษีหัก ณ ที่จ่ายนิติบุคคล ภ.ง.ด. 53</span>
      <div>
        แบบยื่นเพื่อแจ้งการหักภาษี ณ ที่จ่ายระหว่างนิติบุคคล ด้วยกัน
        ซึ่งเอกสารที่ว่านี้จะต้องนำส่งภายในวันที่ 7 ของเดือนถัดไป
        แต่หากเดือนไหนไม่มีการหักก็ไม่ต้อง นำส่ง
      </div>
      <br />

      <span class="bold">แบบแสดงรายการสรุปภาษีซื้อขาย ภพ. 30 </span>
      <div>
        แบบแสดงรายการสรุปภาษีซื้อ ภาษีขาย เพื่อนำส่ง
        สรรพากรโดยผู้มีหน้าที่จัดทำคือ เจ้าของธุรกิจที่มีรายได้มากกว่า 1.8
        ล้านบาท/ปี และได้ทำการขึ้นทะเบียนภาษีมูลค่าเพิ่มแล้ว
        ต้องทำส่งให้กรมสรรพากรทุกเดือนภายในวันที่ 15 ของเดือนถัดไป
        หรือสามารถยื่นผ่านทางอินเตอร์เน็ตได้
      </div>
    </div>
  </template-info>
</template>
<script>
import BackgroundImg from "@/assets/images/infos/documents_corp.png";

export default {
  name: "Documents",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
